import styled from "styled-components";

export const Container = styled.header`
  display: flex;
  align-items: center;
  width: 58vw;
`;
export const LogoContainer = styled.div`
  margin-right: 1em;
`;
export const NavigationContainer = styled.div`
  width: 300px;
  margin-left: 2em;
`;
export const HeaderRight = styled.div`
  margin-left: auto;
`;
